module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNDgwIiB3aWR0aD0iNjQwIiB2aWV3Qm94PSIwIDAgNjQwIDQ4MCI+CiAgPHBhdGggZmlsbD0iIzM3N2UzZiIgZD0iTS4xIDBoNjQwdjQ4MEguMXoiLz4KICA8cGF0aCBmaWxsPSIjZmZmIiBkPSJNLjEgOTZoNjQwdjI4OEguMXoiLz4KICA8cGF0aCBmaWxsPSIjYjQwYTJkIiBkPSJNLjEgMTQ0aDY0MHYxOTJILjF6Ii8+CiAgPHBhdGggZD0iTTMyMCAxNTMuMTY3bDU2LjQyNyAxNzMuNjY2LTE0Ny43My0xMDcuMzNoMTgyLjYwNWwtMTQ3LjczIDEwNy4zM3oiIGZpbGw9IiNlY2M4MWQiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/4x3/sr.svg
// module id = ./node_modules/flag-icon-css/flags/4x3/sr.svg
// module chunks = 0